import { Outlet } from "react-router-dom";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function NoHeaderLayout() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        mt: 5,
      }}
    >
      <Box mb={10}>
        <Typography variant="h2-bold">Term Life Dashboard</Typography>
      </Box>
      <Outlet />
    </Box>
  );
}
